module.exports = __webpack_public_path__ + "img/1-text-query.95f7a05a.png";